(ns frontend.ui.component.icon.style)

(defn icon-container
  []
  {:display "inline-block"
   :flex    "0 0 auto"
   :cursor  "pointer"})

(defn left-padded-container
  []
  ^{:extend icon-container}
  {:padding-left "8px"})
